var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-password-reset"},[_c('div',{staticClass:"header"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logoVoodoo}})]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }